import * as React from 'react';

import {DOMNode, domToReact, htmlToDOM} from 'html-react-parser';
import RenderTabs, { ITabData } from '../../../../Components/Tabs';

export interface ITabsProps {
    /* DOM to parse */
    dom: string | DOMNode[];
    /** Click event to bind to A tag */
    onClick?: (event) => void;
    /** Unsafe config */
    config?: any;
    componentMapper: (maybeComponent: string, maybeContent: string, maybeConfig) => React.Component | React.ReactNode;
}

const Tabs: React.FunctionComponent<ITabsProps> = (props) => {

    const tabsData: {[key: string]: ITabData} = {};
    const parserOptions = {
        replace: (domNode: any) => {
            if (domNode.name) {
                if (domNode.attribs['data-subcomponent']){
                    const maybeConfig = JSON.parse(domNode.attribs['data-config'] || '{}');
                    const maybeComponent = domNode.attribs['data-subcomponent'];
                    const maybeContent = domNode.children ?? '';
                    const { class: className, ...rest } = domNode.attribs;
                    const mappedComponent = props.componentMapper(maybeComponent, maybeContent, maybeConfig);

                    if (mappedComponent) {
                        return (
                            <domNode.name className={className} {...rest}>
                                {mappedComponent}
                            </domNode.name>
                        );
                    }
                }
                if (domNode.attribs['data-component']){
                    const maybeConfig = JSON.parse(domNode.attribs['data-config'] || '{}');
                    const maybeComponent = domNode.attribs['data-component'];
                    const maybeContent = domNode.children ?? '';
                    const { class: className, ...rest } = domNode.attribs;
                    const mappedComponent = props.componentMapper(maybeComponent, maybeContent, maybeConfig);

                    if (mappedComponent) {
                        return (
                            <domNode.name className={className} {...rest}>
                                {mappedComponent}
                            </domNode.name>
                        );
                    }
                }
                const isParentTab = domNode.parent?.attribs.class?.split(' ').includes('tabbed-content__tab') || false;
                const isTab = domNode.attribs.class?.split(' ').includes('tabbed-content__tab') || false;
                const isPanel = domNode.attribs.class?.split(' ').includes('tabbed-content__panel') || false;
                if (domNode.name === 'a' && domNode.parent && isParentTab) {
                    const {class: className, rel: tab, ...rest} = domNode.attribs;
                    const inner = domToReact(domNode.children, {});
                    const testId = domNode.attribs['data-testid'] || null;
                    tabsData[tab] = {
                        ...tabsData[tab],
                        title: inner,
                        testId: testId,
                        className,
                    };
                    return (null);
                }

                if (domNode.name==='li' && isTab) {
                    const inner = domToReact(domNode.children, parserOptions);
                    const { class: className, ...rest } = domNode.attribs;
                    return (null);
                }

                if (domNode.name==='ul' && domNode.attribs.class==='tabbed-content__tabs') {
                    const inner = domToReact(domNode.children, parserOptions);
                    const { class: className, ...rest } = domNode.attribs;

                    return (null);
                }

                if (domNode.name==='div' && domNode.attribs.class==='tabbed-content__panel-group') {
                    const { class: className, ...rest } = domNode.attribs;
                    const inner = domToReact(domNode.children, parserOptions);
                    return (null);
                }

                if (domNode.name==='div' && isPanel) {
                    const { class: className, id: tab, ...rest } = domNode.attribs;
                    const inner = domToReact(domNode.children, parserOptions);

                    return (null);
                }

                if (domNode.name==='div' && domNode.attribs.class==='tabbed-content__panel-heading') {
                    const { class: className, ...rest } = domNode.attribs;
                    const tab = domNode.parent.attribs.id;

                    const inner = domToReact(domNode.children, {});
                    tabsData[tab] = {
                        ...tabsData[tab],
                        mobileTitle: inner,
                        mobileClassName: className,
                    };
                    return null;
                }

                if (domNode.name==='div' && domNode.attribs.class==='tabbed-content__panel-content') {
                    const { class: className, ...rest } = domNode.attribs;
                    const tab = domNode.parent.attribs.id;
                    const inner = domToReact(domNode.children, parserOptions);
                    tabsData[tab] = {
                        ...tabsData[tab],
                        content: inner,
                        contentClassName: className,
                        panelClassName: domNode.parent.attribs.class,
                    };
                    return null;
                }
            }
            return false;
        },
    };
    // Main output

    const domTree = Array.isArray(props.dom) ? props.dom : htmlToDOM(props.dom.replace(/>\s+</g, '><'));
    domToReact(domTree, parserOptions);
    return (
        <RenderTabs tabs={tabsData} activeTab={props.config?.activeTab} hasWrapper={true} disableHash={props.config?.disableHash} scrollToTop={props.config?.scrollToTop}/>
    );
};

Tabs.displayName = 'Tabs';

export default Tabs;
